<template>
  <div class="field-footer">
    <div class="container">
      <template v-for="(field, index) in data.Footer">
        <div :key="'data_' + index" v-if="false">{{ field }}</div>
        <Field
          class="field-footer-inline"
          :data="field"
          :parent="data"
          :sectionid="sectionid"
          :pageid="pageid"
          :key="'field_' + index"
        />
      </template>
    </div>
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'

export default {
  name: 'FieldFooter',
  components: {},
  props: {
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String
  },
  data: () => {
    return {
      PreApproveMe
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.field-footer {
  border-top: solid 1px $medium-gray;
  background: $lighter-gray;
  padding: 1rem 0;
  text-align: right;
  > .container {
    width: $footer-container-width;
  }
  .field-footer-inline {
    display: inline-block;
    margin-left: 12px;
  }
}
</style>
